var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgChartSquare = function SvgChartSquare(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 28,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000B31",
    d: "M18.889 2.333H9.112c-4.247 0-6.778 2.532-6.778 6.779v9.765c0 4.258 2.531 6.79 6.778 6.79h9.765c4.247 0 6.778-2.532 6.778-6.779V9.112c.012-4.247-2.52-6.779-6.767-6.779m-8.26 17.384a.58.58 0 0 1-.584.583H6.79a.58.58 0 0 1-.583-.583v-5.39c0-.735.595-1.33 1.33-1.33h2.508c.327 0 .584.256.584.583zm5.576 0a.58.58 0 0 1-.583.583h-3.255a.58.58 0 0 1-.584-.583V9.03c0-.735.596-1.33 1.33-1.33h1.774c.735 0 1.33.595 1.33 1.33v10.687zm5.589 0a.58.58 0 0 1-.584.583h-3.255a.58.58 0 0 1-.583-.583v-4.142c0-.327.256-.583.583-.583h2.509c.735 0 1.33.595 1.33 1.33z"
  })));
};
export default SvgChartSquare;